import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  infoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: {
      xs: '10px',
      md: '16px',
    },
  },
  labelChipsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: {
      xs: '6px',
      md: '10px',
    },
  },
  chips: {
    height: '32px',
    padding: {
      xs: '6px 10px',
      md: '8px 16px',
    },
    fontSize: '14px',
    cursor: 'default',
    backgroundColor: 'neutral.white',
    gap: '8px',
    borderColor: 'rgba(0,0,0,0.2)',
    color: 'grey.600',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: {
      xs: '16px',
      md: '24px',
    },
    flexBasis: { xs: '100%', md: '80%' },
    flexWrap: 'wrap',
    width: '100%',
  },
  columnWithDivider: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    width: { xs: '100%', md: 'unset' },
    gap: {
      xs: '16px',
      md: '24px',
    },
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: {
      xs: '12px',
      md: '16px',
    },
    width: '100%',
    maxWidth: { xs: '100%', md: '295px' },
  },
  columnDivider: {
    borderColor: 'border.dark',
  },
  cardItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    border: '1px solid',
    borderColor: 'border.dark',
    padding: '10px',
    borderRadius: '8px',
    maxWidth: { xs: '100%', md: '295px' },
    minWidth: { xs: '100%', md: '295px' },
    height: '40px',
    maxHeight: '40px',
    textDecoration: 'none',
    color: 'inherit',
  },
  brandLogo: {
    width: '20px',
    height: '20px',
  },
  cardItemContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
